function RetryError(message, response) {
  this.message = message;
  this.response = response;
  this.stack = Error().stack;
}

RetryError.prototype = Object.create(Error.prototype);
RetryError.prototype.name = 'RetryError';
RetryError.prototype.constructor = RetryError;

export default RetryError;
